import React, { useState } from "react";
import "./App.css";
import Navigation from "./components/Navigation";
import Hero from "./components/Hero";
import MeetYourTherapist from "./components/MeetYourTherapist";
import MyApproach from "./components/MyApproach";
import SpacesForHealing from "./components/SpacesForHealing";
// import Testimonials from "./components/Testimonials";
import WhenYouFeelReady from "./components/WhenYouFeelReady";
import LetterToYou from "./components/LetterToYou";
import QueryBox from "./components/QueryBox";
import Footer from "./components/Footer";
import ComingSoon from "./components/ComingSoon";

function App() {
  const [showComingSoon, setShowComingSoon] = useState(false);

  return (
    <div className="App">
      <Navigation onNewsletterClick={() => setShowComingSoon(true)} />
      <Hero />
      <LetterToYou />
      <SpacesForHealing />
      <WhenYouFeelReady />
      <MeetYourTherapist />
      <MyApproach />
      {/* <Testimonials /> */}
      <QueryBox />
      <Footer />
      {showComingSoon && (
        <ComingSoon onClose={() => setShowComingSoon(false)} />
      )}
    </div>
  );
}

export default App;
